<div class="container_guide" (click)="handlePush()">
  <h3>114723550 • Fundação Copel</h3>
  <p>Oncologia</p>
  <div class="type_guide danger">
    <p>Guia atrasado em 3d, 19h e 25min</p>
  </div>
</div>
